import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/identity/requests/request.service';
import { SearchData } from './search.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  pageIndex: number = 0;
  pageSize: number = 10;
  filter?: Array<{ key: string; value: string }>;
  sortField?: string;
  sortOrder?: string = "ascend";
  searchField?: string = "id";
  searchValue?: string;
  searchData?: SearchData;

  constructor(
    private requestService: RequestService,
  ) { }

  resetSearchFields() {
    this.pageIndex = 1;
    this.pageSize = 10;
    this.sortField = null;
    this.searchField = "id"
    this.searchValue = null;
    this.filter = null;
  }

  search(searchValue: string|null = null){
    this.searchValue = searchValue;

    switch (this.searchData) {
      case SearchData.Drafts:
        this.requestService.getDrafts(
          this.pageIndex, this.pageSize, this.sortField, this.sortOrder, this.filter, this.searchField, this.searchValue)
        break;
      case SearchData.Requests:
        this.requestService.getRequests(
          this.pageIndex, this.pageSize, this.sortField, this.sortOrder, this.filter, this.searchField, this.searchValue);
        break;
      default:
        console.error("No one search Data Field specified");
        break;
    }
  }
}
